import { render } from "./IconLogo2.vue?vue&type=template&id=0ede9a73"
import script from "./IconLogo2.vue?vue&type=script&lang=js"
export * from "./IconLogo2.vue?vue&type=script&lang=js"
script.render = render

export default script